import type { ApiChoiceResponseItem } from '@/features/ChoicesLists/Api/types';
import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';

export class ChoicesApiHttpService extends HttpService {
  loadCitiesByPlz(
    ...requestArguments: string[]
  ): HttpClientResponse<ApiChoiceResponseItem[]> {
    return this.httpClient.get(`cities?postcode=${requestArguments[0]}`);
  }

  getPreliminaryContracts(
    ...requestArguments: string[]
  ): HttpClientResponse<ApiChoiceResponseItem[]> {
    return this.httpClient.get(`kunde/${requestArguments[0]}/vorvertraege`);
  }

  // KFZ-V2-Hersteller (Softfair-V2-Fahrzeugsuche). Das Sparte-Präfix setzt der Client,
  // für campv2 also /campv2/v2/hersteller (backendseitig auf /camp/v2/hersteller gemappt).
  loadHersteller(): HttpClientResponse<ApiChoiceResponseItem[]> {
    return this.httpClient.get('v2/hersteller');
  }
}
